'use client';
import { useEffect } from 'react';
import { getOrCreateAppIdFromCookiesClient } from '@/lib/app-id-client';

export default function AppIdInitializer() {
  useEffect(() => {
    getOrCreateAppIdFromCookiesClient();
  }, []);

  return null;
}
